<script>
  import { fade } from "svelte/transition";

  export let visible = false;
  export let isMobileOrTablet = false;
  export let onDismiss = () => {};
  export let iconSrc = "images/icon-clickndrag.svg";
  export let message = isMobileOrTablet ? "Swipe to rotate" : "Click & Drag";

  let timeoutId;

  function handleDismiss(reason = "unknown") {
    console.log("[TutorialOverlay] dismiss requested in component", { reason, visible });
    if (timeoutId) clearTimeout(timeoutId);
    onDismiss(reason);
  }

  /** Dismiss as soon as the user engages (not only on click — drag/long-press often skip click). */
  function handlePointerDown(e) {
    if (e.button !== 0) return;
    handleDismiss("user-pointer");
  }

  $: if (visible) {
    console.log("[TutorialOverlay] visible in component", {
      isMobileOrTablet,
      message,
      audioInitOverlayPresent: !!document.getElementById("audio-init-overlay"),
    });
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => handleDismiss("auto-timeout"), 5000);
  }
</script>

{#if visible}
  <div
    class="tutorial-wrapper"
    role="dialog"
    aria-label={message}
    on:pointerdown={handlePointerDown}
    on:keydown={(e) => e.key === "Enter" && handleDismiss("enter-key")}
    tabindex="-1"
    transition:fade={{ duration: 500 }}
  >
    <div class="tutorial-card">
      <img
        class="tutorial-icon"
        src={iconSrc}
        alt=""
        width="80"
        height="80"
      />
      <p class="tutorial-text">{message}</p>
    </div>
  </div>
{/if}

<style>
  .tutorial-wrapper {
    position: fixed;
    inset: 0;
    /* iOS: use viewport-relative height so flex centering works (dvh + -webkit-fill-available) */
    height: 100vh;
    height: 100dvh;
    min-height: -webkit-fill-available;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 100;
    pointer-events: auto;
  }

  .tutorial-card {
    width: 150px;
    padding: 1.5rem 1.25rem;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    background: rgba(35, 31, 31, 0.8);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
  }

  .tutorial-icon {
    object-fit: contain;
    flex-shrink: 0;
  }

  .tutorial-text {
    color: #ffffff;
    font-size: 1.25rem;
    font-family: var(--font-body, inherit), sans-serif;
    text-align: center;
    margin: 0;
  }
</style>
